export const EXTRA_TEXT_TYPE = 'text';

export const EXTRA_TITLE_TYPE = 'title';

export const EXTRA_SUBTITLE_TYPE = 'subtitle';

export const EXTRA_LINK_TYPE = 'link';

export const EXTRA_SUBMIT_TYPE = 'submit';

export const EXTRA_BUTTON_TYPE = 'button';
